import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useParallax } from 'react-scroll-parallax';
import './WelcomeSection.css';
import image1 from '../../assets/10.jpg';
import image2 from '../../assets/gladys_3.png';
import image3 from '../../assets/11.jpg';

function WelcomeSection() {
  const { ref } = useParallax({ speed: -5 });
  const navigate = useNavigate(); // Inicializa el hook
  
  const parallaxTopImage = useParallax({
    translateX: [0, 35],
    translateY: [0, -25, 0],
    rotate: [0, 10, 0],
    speed: 10,
    easing: 'easeOutQuart'
  });
  
  const parallaxBottomImage = useParallax({
    translateX: [0, -35],
    translateY: [0, -25, 0],
    rotate: [0, -10, 0],
    speed: 10,
    easing: 'easeOutQuart'
  });

  const handleClick = () => {
    navigate('/dra-quintero'); // Navega a la ruta al hacer clic
  };

  return (
    <section className="welcome-section" ref={ref}>
      <div className="welcome-content">
        <div className="welcome-text">
          <h2>
            <span className="light">Bienvenido al</span>
            <span className="bold">Consultorio Dra. Quintero</span>
          </h2>
          <h3>🔬 Medicina Estética Científica</h3>
          <p>
            <span className="icon">🩺</span> Ofrezco tratamientos personalizados de dermatología estética y medicina regenerativa. Como especialista certificada, combino:
          </p>
          <ul className="servicios-list">
            <li>💎 Tecnología de última generación</li>
            <li>🎯 Técnicas mínimamente invasivas</li>
            <li>🌿 Resultados naturales y armónicos</li>
            <li>🛡️ Enfoque preventivo integral</li>
          </ul>
          <button className="conoce-mas" onClick={handleClick}>
            &nbsp; Descubre mi método
          </button>
        </div>

        <div className="welcome-images">
          <img
            ref={parallaxTopImage.ref}
            src={image1}
            alt="Tratamiento facial"
            className="image-small top"
          />
          <img
            src={image2}
            alt="Dra. Quintero trabajando"
            className="image-large center"
          />
          <img
            ref={parallaxBottomImage.ref}
            src={image3}
            alt="Resultado capilar"
            className="image-small bottom"
          />
        </div>
      </div>
    </section>
  );
}

export default WelcomeSection;